module.exports = __webpack_public_path__ + "img/upload.0910c9ed.jpg";